import { render, staticRenderFns } from "./diseaseInfo.vue?vue&type=template&id=7751e599&"
import script from "./diseaseInfo.vue?vue&type=script&lang=js&"
export * from "./diseaseInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports